import { render, staticRenderFns } from "./otherProfitLogAdd.vue?vue&type=template&id=d9de60b0&scoped=true&"
import script from "./otherProfitLogAdd.vue?vue&type=script&lang=js&"
export * from "./otherProfitLogAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9de60b0",
  null
  
)

export default component.exports